import React from "react";
import { useSearchParams } from "react-router-dom";
import WeeklyTimeSummaries from "./WeeklyTimeSummaries";

const WeeklyTimeSummariesPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  let date = searchParams.get("date");
  return <WeeklyTimeSummaries isoDateParam={date} />;
};

export default WeeklyTimeSummariesPage;
